import { KycVerification } from '../../shared/types';

const OS_LABELS: Record<string, string> = {
  android: 'Android',
  ios: 'iOS',
  windows: 'Windows',
  macos: 'macOS',
  linux: 'Linux',
  other: 'Other',
};

export const deviceLabel = (row: Pick<KycVerification, 'device_type' | 'device_os'>): string | null => {
  const type = row.device_type
    ? row.device_type.charAt(0).toUpperCase() + row.device_type.slice(1)
    : '';
  const os = row.device_os ? OS_LABELS[row.device_os] ?? row.device_os : '';
  const label = [type, os].filter(Boolean).join(' · ');
  return label || null;
};
